<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <!-- Preload + load fonts here (not via a CSS @import) so the request starts
         at HTML-parse time. display=swap paints fallback text immediately. -->
    <link
      rel="preload"
      as="style"
      href="https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Newsreader:opsz,wght@6..72,600;6..72,700&display=swap"
    />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Newsreader:opsz,wght@6..72,600;6..72,700&display=swap"
    />
    <link rel="icon" href="/favicon.ico" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, viewport-fit=cover"
    />
    <meta name="theme-color" content="#2f62e8" />

    <meta
      name="description"
      content="Manifest - Transform raw startup ideas into investor-ready businesses with AI-powered tools. Generate business models, pitch decks, patents, and legal documents."
    />
    <meta
      name="keywords"
      content="startup, AI, business model, pitch deck, entrepreneurship, investment, patents, legal documents"
    />
    <meta name="author" content="Manifest" />

    <meta property="og:title" content="Manifest - AI-Powered Startup Building Platform" />
    <meta
      property="og:description"
      content="Transform raw ideas into investor-ready startups. Generate business models, pitch decks, and legal documents with AI."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://manifeststartup.com" />
    <meta property="og:image" content="/logo512.png" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Manifest - AI-Powered Startup Building Platform" />
    <meta
      name="twitter:description"
      content="Transform raw ideas into investor-ready startups with AI-powered tools."
    />

    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://manifeststartup.com" />

    <link rel="apple-touch-icon" href="/logo192.png" />
    <link rel="manifest" href="/manifest.json" />

    <title>Manifest - AI-Powered Startup Building Platform</title>

    <script type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "Manifest",
        "description": "AI-powered platform for transforming raw startup ideas into investor-ready businesses. Generate business models, pitch decks, patents, and legal documents.",
        "url": "https://manifeststartup.com",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web Browser",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        },
        "featureList": [
          "AI-powered business model generation",
          "Pitch deck creation",
          "Patent and intellectual property documentation",
          "Legal document generation",
          "Investment tracking",
          "Cap table management",
          "AI voice agent for idea qualification",
          "Website testing and analysis"
        ],
        "creator": {
          "@type": "Organization",
          "name": "Manifest",
          "url": "https://manifeststartup.com"
        },
        "potentialAction": {
          "@type": "CreateAction",
          "name": "Create Startup Idea",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://manifeststartup.com/ideas/new"
          }
        }
      }
    </script>

    <script type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Manifest API",
        "description": "REST API for programmatic access to Manifest startup building features",
        "url": "https://manifeststartup.com/api/v1",
        "applicationCategory": "DeveloperApplication",
        "operatingSystem": "Any",
        "offers": {
          "@type": "AggregateOffer",
          "lowPrice": "0",
          "highPrice": "99",
          "priceCurrency": "USD",
          "offerCount": "3"
        }
      }
    </script>
  </head>
  <body>
    <noscript class="manifest-noscript-fallback">
      <h1>Talk through your startup idea</h1>
      <p>
        Manifest helps founders turn raw ideas into structured, investor-ready startup artifacts.
        Enable JavaScript for the full interactive workspace.
      </p>
      <p><a href="/auth">Sign in to Manifest</a></p>
    </noscript>
    <div id="root">
      <main id="manifest-static-shell" class="manifest-static-shell">
        <h1>Talk through your startup idea</h1>
        <p>Loading Manifest…</p>
      </main>
    </div>
    <script src="/spa-shell-bootstrap.js"></script>
    <script type="module" src="/src/index.tsx"></script>
  </body>
</html>
